import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.css";

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-left">
        © {new Date().getFullYear()} Invertible
      </div>

      <div className="footer-links">

        <Link to="/contact">Contact</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/impressum">Impressum</Link>
      </div>
    </footer>
  );
}

export default Footer;